export enum enmCountType {
    CONFIRM = 1,
    WAIT = 2,
    NOTCONFIRM = 3,
    NEW = 4,
    CANCEL = 5,
    CHANGED = 6,
    WARNING = 7
}